var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};
OCS.Viewer.Classes.VectorSource = new Class({
    Extends: OCS.Viewer.Classes.AbstractSource,
    class_name: "VectorSource",
    options: {
        init: {
            contour_delta: 5,
            contour_resolution: 100,
            interpolation_factor: 2
        },
        metadata: {
            source_type: 'Vector'
        }
    },
    initialize: function (ops) {
        this.parent(ops);

        if (this.get_datatype() === "shapefile") {
            this.preprocess_shapefile();
        }
        this.bound_events.source_changed = this.source_changed.bind(this);
    },
    features_added: function () {
        this.fireEvent('changed', this, 1);
        this.fireEvent('refresh', this, 2);
        this.fireEvent('features_added', this, 3);
    },
    add_feature: function (feature) {
        var source = this.get_source();
        source.addFeature(feature);
        this.features_added();
    },
    add_feature_obj: function (feature_obj) {
        feature_obj.addEvent('changed', this.bound_events.source_changed);
        this.add_feature(feature_obj.get_feature());
    },
    add_features: function (features) {
        var source = this.get_source();
        source.addFeatures(features);
        this.features_added();
    },
    features_removed: function () {
        this.fireEvent('changed', this, 1);
        this.fireEvent('refresh', this, 2);        
        this.fireEvent('features_removed', this, 1);
    },
    remove_feature: function (feature) {
        var source = this.get_source();
        source.removeFeature(feature);
        this.features_removed();
    },
    remove_feature_obj: function (feature_obj) {
        feature_obj.removeEvent('changed', this.bound_events.source_changed);
        this.remove_feature(feature_obj.get_feature());
    },
    clear: function () {
        var source = this.get_ol_object();
        if (source) {
            source.clear();
        }
    },
    create: function () {
        if (!this.get_ol_object()) {
            this.destroy_source();
            var options = this.options;
            this.set_ol_object(new ol.source.Vector(this.get_source_ops(options)));
            this.addEvent('features_added', this.data_source_ready.bind(this));
        }
        return this.get_ol_object();
    },
    process_polygons: function () {
        if (this.options.init.format) {
            var features = this.options.init.format.readFeatures(this.get_json_data());
            this.add_features(features);
        }
    },
    process_lightning: function () {

    },
    /**
     * @method process_gridded_netcdf - Method for building contour data source
     */
    process_gridded_netcdf: function () {
        this.parent();
        var frac1, frac2, point1, point2, pointlat1, pointlon1, lb_int_count, current_contour, datarow, datacol, pointlat2, pointlon2;
        var data = this.get_json_data();
        var grid_properties_origin = data.data['grid-properties'].origin;
        var grid_properties_delta = data.data['grid-properties'].delta;

        var variable = this.get_variables()[0],
                adj_contour_delta = this.options.init.contour_delta,
                int_factor = this.options.init.interpolation_factor,
                origin_lon = grid_properties_origin[0],
                origin_lat = grid_properties_origin[1],
                delta_lon = parseFloat(grid_properties_delta[0] / int_factor),
                delta_lat = parseFloat(grid_properties_delta[1] / int_factor);

        var base_data = data.data.variables[variable.parm].data;
        var ul_data = 0;
        var ll_data = 0;
        var ur_data = 0;
        var lr_data = 0;

        var util = OCS.Viewer.Functions.get_utilities();
        var minmax = util.get_2dmin_array_minmax(base_data);

        var data_min = minmax.min;
        var data_max = minmax.max;

        //get the rounded data min and max
        var floored_data_min = Math.floor(data_min);
        var cieled_data_max = Math.ceil(data_max);

        //get the closest contour value to our max/min
        var starting_contour = floored_data_min - (floored_data_min % adj_contour_delta);
        var ending_countour = cieled_data_max + (cieled_data_max % adj_contour_delta);

        var source_max = this.options.init.max_val;
        var source_min = this.options.init.min_val;

        if (source_max || source_min) {
            // if options.min_val and/or options.max_val are set, use them
            source_min = parseFloat(source_min);
            source_max = parseFloat(source_max);
            if (source_min !== source_max) {
                starting_contour = (source_min) ? source_min - (source_min % adj_contour_delta) : starting_contour;
                ending_countour = (source_max) ? source_max + (source_max % adj_contour_delta) : ending_countour;
            } else {
                // The values match, so draw the 1 contour that is specified. 
                starting_contour = source_min;
                ending_countour = source_min;
            }
        }


        //interpolate datapoints to smooth contours
        var interpolated_data = util.interpolate_data(base_data, int_factor);
        var intersect_count = 0;
        var multilines = {};

        //iterate through each contour we want to draw.
        for (current_contour = starting_contour; current_contour <= ending_countour; current_contour += adj_contour_delta) {
            //reset our interval counter for the new interval
            lb_int_count = 10;

            //interate throught each data row, starting at the end and working backwords. This is due
            //	to the way the data is formatted in the data file.		  		 
            for (datarow = interpolated_data.length - 1; datarow >= 1; datarow--) {
                //interate through each data column, starting at the beginning. We start at index 1 because we 
                //	check that column, and the column before it.
                for (datacol = 1; datacol < interpolated_data[datarow].length; datacol++) {
                    //check that our data value is not null, as we dont want to draw anything if it is.
                    if (interpolated_data[datarow][datacol] !== null && interpolated_data[datarow - 1][datacol] !== null) {
                        intersect_count = 0;

                        ul_data = interpolated_data[datarow][datacol - 1];       //  ul | ur
                        ll_data = interpolated_data[datarow - 1][datacol - 1];   //  ---+---
                        ur_data = interpolated_data[datarow][datacol];           //  ll | lr
                        lr_data = interpolated_data[datarow - 1][datacol];


                        if (((ul_data >= current_contour && ll_data <= current_contour) || (ul_data <= current_contour && ll_data >= current_contour)) && (ul_data !== null && ll_data !== null)) {
                            intersect_count++;
                        }

                        if (((ur_data >= current_contour && lr_data <= current_contour) || (ur_data <= current_contour && lr_data >= current_contour)) && (ur_data !== null && lr_data !== null)) {
                            intersect_count++;
                        }

                        if (((ul_data >= current_contour && ur_data <= current_contour) || (ul_data <= current_contour && ur_data >= current_contour)) && (ul_data !== null && ur_data !== null)) {
                            intersect_count++;
                        }

                        if (((ll_data >= current_contour && lr_data <= current_contour) || (ll_data <= current_contour && lr_data >= current_contour)) && (ll_data !== null && lr_data !== null)) {
                            intersect_count++;
                        }

                        frac1 = null;
                        frac2 = null;
                        if (intersect_count === 2) {
                            point1 = null;
                            point2 = null;

                            if ((ul_data >= current_contour && ll_data <= current_contour) || (ul_data <= current_contour && ll_data >= current_contour)) { //checked
                                //left side
                                if (frac1 === null) {
                                    frac1 = (ll_data < ul_data) ? (util.get_frac(current_contour, ll_data, ul_data, 0, 1)) : (1 - util.get_frac(current_contour, ul_data, ll_data, 0, 1));

                                    pointlat1 = origin_lat + (delta_lat * (datarow - 1)) + (delta_lat * frac1);
                                    pointlon1 = origin_lon + (delta_lon * (datacol - 1));// + (delta_lon * frac1);
                                    point1 = new ol.geom.Point(ol.proj.transform([Number(pointlon1), Number(pointlat1)], this.options.display_projection, this.options.projection));
                                }

                            }

                            if ((ur_data >= current_contour && lr_data <= current_contour) || (ur_data <= current_contour && lr_data >= current_contour)) {
                                //right side
                                if (frac1 === null) {
                                    frac1 = (lr_data < ur_data) ? (util.get_frac(current_contour, lr_data, ur_data, 0, 1)) : (1 - util.get_frac(current_contour, ur_data, lr_data, 0, 1));

                                    pointlat1 = origin_lat + (delta_lat * (datarow - 1)) + (delta_lat * frac1);
                                    pointlon1 = origin_lon + (delta_lon * datacol);// + (delta_lon * frac1);

                                    point1 = new ol.geom.Point(ol.proj.transform([Number(pointlon1), Number(pointlat1)], this.options.display_projection, this.options.projection));
                                } else {
                                    frac2 = (lr_data < ur_data) ? (util.get_frac(current_contour, lr_data, ur_data, 0, 1)) : (1 - util.get_frac(current_contour, ur_data, lr_data, 0, 1));

                                    pointlat2 = origin_lat + (delta_lat * (datarow - 1)) + (delta_lat * frac2);
                                    pointlon2 = origin_lon + (delta_lon * datacol);// + (delta_lon * frac2);

                                    point2 = new ol.geom.Point(ol.proj.transform([Number(pointlon2), Number(pointlat2)], this.options.display_projection, this.options.projection));
                                    this.create_line_segment(point1, point2, current_contour, multilines);

                                }
                            }

                            if ((ul_data >= current_contour && ur_data <= current_contour) || (ul_data <= current_contour && ur_data >= current_contour)) {
                                //top
                                if (frac1 === null) {
                                    frac1 = (ul_data < ur_data) ? (util.get_frac(current_contour, ul_data, ur_data, 0, 1)) : (1 - util.get_frac(current_contour, ur_data, ul_data, 0, 1));

                                    pointlat1 = origin_lat + (delta_lat * datarow);// + (delta_lat * frac1);
                                    pointlon1 = origin_lon + (delta_lon * (datacol - 1)) + (delta_lon * frac1);
//
                                    point1 = new ol.geom.Point(ol.proj.transform([Number(pointlon1), Number(pointlat1)], this.options.display_projection, this.options.projection));
                                } else {
                                    frac2 = (ul_data < ur_data) ? (util.get_frac(current_contour, ul_data, ur_data, 0, 1)) : (1 - util.get_frac(current_contour, ur_data, ul_data, 0, 1));

                                    pointlat2 = origin_lat + (delta_lat * datarow);// + (delta_lat * frac2);
                                    pointlon2 = origin_lon + (delta_lon * (datacol - 1)) + (delta_lon * frac2);

                                    point2 = new ol.geom.Point(ol.proj.transform([Number(pointlon2), Number(pointlat2)], this.options.display_projection, this.options.projection));
                                    this.create_line_segment(point1, point2, current_contour, multilines);

                                }
                            }

                            if ((ll_data >= current_contour && lr_data <= current_contour) || (ll_data <= current_contour && lr_data >= current_contour)) {
                                //bottom
                                if (frac1 === null) {
                                    if (ll_data > current_contour + adj_contour_delta) {
                                        ll_data = current_contour;
                                    }

                                    frac1 = (ll_data < lr_data) ? (util.get_frac(current_contour, ll_data, lr_data, 0, 1)) : (1 - util.get_frac(current_contour, lr_data, ll_data, 0, 1));
                                    pointlat1 = origin_lat + (delta_lat * (datarow - 1));// + (delta_lat * frac1);
                                    pointlon1 = origin_lon + (delta_lon * (datacol - 1)) + (delta_lon * frac1);
//
                                    point1 = new ol.geom.Point(ol.proj.transform([Number(pointlon1), Number(pointlat1)], this.options.display_projection, this.options.projection));
                                } else {
                                    frac2 = (ll_data < lr_data) ? (util.get_frac(current_contour, ll_data, lr_data, 0, 1)) : (1 - util.get_frac(current_contour, lr_data, ll_data, 0, 1));

                                    pointlat2 = origin_lat + (delta_lat * (datarow - 1));// + (delta_lat * frac2);
                                    pointlon2 = origin_lon + (delta_lon * (datacol - 1)) + (delta_lon * frac2);

                                    point2 = new ol.geom.Point(ol.proj.transform([Number(pointlon2), Number(pointlat2)], this.options.display_projection, this.options.projection));
                                    this.create_line_segment(point1, point2, current_contour, multilines);
                                }
                            }

                        }
                    }
                }
            }
        }

        var multiline_keys = Object.keys(multilines);
        var variables = this.get_variables();
        if (multiline_keys.length) {
            var i;
            for (i = 0; i < multiline_keys.length; i++) {
                var feature = new ol.Feature(multilines[multiline_keys[i]]);
                feature.set(variables[0].parm, multiline_keys[i]);
                this.add_feature(feature);
            }

        }

    },
    create_line_segment: function (point1, point2, current_contour, multilines) {
        if (!multilines[current_contour]) {
            multilines[current_contour] = new ol.geom.MultiLineString([[point1.getCoordinates(), point2.getCoordinates()]]);
        } else {
            multilines[current_contour].appendLineString(new ol.geom.LineString([point1.getCoordinates(), point2.getCoordinates()]));
        }
    },
    /**
     * @method process_netcdf - Method for building point data source
     */
    process_netcdf: function () {
        // Make sure we account for null values appropriately
        if (this.options.init.min_val === 'nan') {
            this.options.init.min_val = null;
        }
        if (this.options.init.max_val === 'nan') {
            this.options.init.max_val = null;
        }
        var data = this.get_json_data();
        var variables = this.get_variables();
        // Point data
        var points = [];
        var lat_data = data.data.lat.data;
        var lon_data = data.data.lon.data;
        var stid_data = data.data.stid.data;

        var i, j;
        for (i = 0; i < lat_data.length; i++) {
            var pointFeature = new ol.Feature(new ol.geom.Point(ol.proj.transform([Number(lon_data[i]), Number(lat_data[i])], this.options.display_projection, this.options.projection)));
            var stid = stid_data[i];
            pointFeature.set('STID', stid);
            for (j = 0; j < variables.length; j++) {
                var point_val = data.data[variables[j].parm].data[i];
                if ((this.options.init.max_val === null || point_val <= this.options.init.max_val) && (this.options.init.min_val === null || point_val >= this.options.init.min_val)) {
                    pointFeature.set(variables[j].parm, point_val);
                }

            }
            points.push(pointFeature);
        }
        this.add_features(points);
    },
    process_nids: function () {

    },
    /*
     * Shapefile related methods
     */
    process_shapefile: function (data) {
        var format = new ol.format.GeoJSON();
        var features = format.readFeatures(data.geojson, {featureProjection: this.options.projection, dataProjection: this.options.display_projection});
        this.add_features(features);
        if (this.options.init.mask) {
            this.make_mask();
        }
    },
    preprocess_shapefile: function () {
        var dataset = this.get_dataset_obj();
        var variables = this.get_variables();
        var shape_url = dataset.get_query_url({data_unit: variables[0].units, data_var: variables[0].parm, protocol: OCS.Viewer.Config.protocol});
        new Shapefile({shp: shape_url}, this.process_shapefile.bind(this));
    },
    make_mask: function () {
        var source = this.get_ol_object();
        //setTimeout(function () {
        var features = this.get_features();
        var ring = new ol.geom.LinearRing([
            new ol.geom.Point(ol.proj.transform([-180, -89.99999], this.options.display_projection, this.options.projection)).getCoordinates(),
            new ol.geom.Point(ol.proj.transform([-180, 89.99999], this.options.display_projection, this.options.projection)).getCoordinates(),
            new ol.geom.Point(ol.proj.transform([0, 89.99999], this.options.display_projection, this.options.projection)).getCoordinates(),
            new ol.geom.Point(ol.proj.transform([180, 89.99999], this.options.display_projection, this.options.projection)).getCoordinates(),
            new ol.geom.Point(ol.proj.transform([180, -89.99999], this.options.display_projection, this.options.projection)).getCoordinates(),
            new ol.geom.Point(ol.proj.transform([0, -89.99999], this.options.display_projection, this.options.projection)).getCoordinates(),
            new ol.geom.Point(ol.proj.transform([-180, -89.99999], this.options.display_projection, this.options.projection)).getCoordinates()
        ], 'XY');

        Object.each(features, function (val, index) {
            var geometry = val.getGeometry();
            geometry.appendLinearRing(ring);
            var feature = new ol.Feature(geometry.getCoordinates());
            source.addFeature(feature);
        }.bind(this));
        source.changed();
        //}.bind(this), 1300);


    },

    /*
     * User data related methods
     */

    process_userdata: function () {

    },

    /*
     * Other related methods
     */
    get_source_ops: function () {
        var ops = {
            projection: this.options.projection
        };
        // Get the request options based on the existing class options
        if (this.options.hasOwnProperty('features')) {
            ops.features = this.options.features;
        }
        if (this.options.hasOwnProperty('format')) {
            ops.format = this.options.format;
        }
        if (this.options.hasOwnProperty('url')) {
            ops.url = this.options.url;
        }
        if (this.options.hasOwnProperty('features_ready')) {
            ops.features_ready = this.options.features_ready;
        }
        return ops;
    },
    get_features: function() {
        var source = this.get_ol_object();
        return source.getFeatures();
    },
    set_features: function (features) {
        this.clear();
        this.add_features(features);

    },
    valueFromLonLat: function (mouse_position) {
        var vs_source = this.get_source();
        var features = vs_source.getFeaturesAtCoordinate(mouse_position);
        return features;
    },
    destroy_source: function () {
        this.clear();
        this.parent();
    }
});
